export const passportNumberPattern = /\d{4} \d{6}/;
export const documentNumberPattern = /^[а-яёА-ЯЁa-zA-Z-—\s\d/]+$/;
